/**
 * Created by brunopoeta on 23/05/17.
 */

export default function SpinnerDirective() {

    return {
        scope: {
            flow: '@',
            label: '@'
        },
        replace: true,
        restrict: 'E',
        templateUrl: window.templateDirectory + '/assets/app/templates/spinner.html'
    }

}
